<template>
  <div class="modalStyle">
    <a-row type="flex" justify="space-between" class="formula" style="margin-bottom:10px;">
      <h3 class="title">{{overseasFlag == '1' ? (taskRaw.aliasName || taskRaw.rawName) : taskRaw.rawName}}</h3>
      <a-button @click="toggleTaskRaw" type="link" class="close-button" icon="close" />
    </a-row>
    <resize-table
      :scroll="{ x: 100, y: height }"
      bordered
      :columns="columns"
      :loading="rawListLoading"
      :data-source="list.records"
      :row-key="record => record.id"
      :pagination="false"
    >
      <template
        v-for="item in ['singUasge','lastTaskUasge','taskUasgePer']"
        :slot="item"
        slot-scope="text"
      >
        {{text|numberFixed(3)}}
      </template>
      <span slot="diffTaskUasge" slot-scope="text" :class="{red:text>0,green:text<0}">
        <a-icon v-if="text !=='' || text !== null || text !== 0" :type="text > 0 ? 'arror-up' :'arror-down'" />
        {{text|numberFixed(3)}}
      </span>
    </resize-table>
  </div>
</template>

<script>
  import { formulaMixins } from '../unitls'
  export default {
      mixins:[formulaMixins],
      data(){
        return{
          overseasFlag: window.localStorage.getItem('overseasFlag'),
          list:{
            records:[]
          },
          rawListLoading:false,
          columns: [
            {
              dataIndex:'formulaName',
              title: '配方名称',
              scopedSlots: {customRender: 'formulaName'},
              sorter: (a, b) => a.formulaName.localeCompare(b.formulaName,'zh'),
              ellipsis: true,
              width:130
            },
            {
              dataIndex:'formulaCode',
              title: '代码',
              sorter: (a, b) => a.rawCode - b.rawCode,
              sortDirections: ['descend', 'ascend'],
              ellipsis: true,
              width:130
            },
            {
              dataIndex:'taskUasgePer',
              align:'center',
              title: '多配方用量(%)',
              scopedSlots: {customRender: 'taskUasgePer'},
              sorter: (a, b) => a.taskUasgePer - b.taskUasgePer,
              sortDirections: ['descend', 'ascend'],
              width:120
            },
            {
              dataIndex:'uasge',
              align:'center',
              title: '用量(吨)',
              scopedSlots: {customRender: 'singUasge'},
              sorter: (a, b) => a.uasge - b.uasge,
              sortDirections: ['descend', 'ascend'],
              width:120
            },
            {
              dataIndex:'lastTaskUasge',
              title: '之前用量(吨)',
              scopedSlots: {customRender: 'lastTaskUasge'},
              sorter: (a, b) => a.lastTaskUasge - b.lastTaskUasge,
              align:'center',
              width:120
            },
            {
              dataIndex:'diffTaskUasge',
              title: '差异(吨)',
              scopedSlots: {customRender: 'diffTaskUasge'},
              sorter: (a, b) => a.diffTaskUasge - b.diffTaskUasge,
              sortDirections: ['descend', 'ascend'],
              align:'center',
              width:120
            },
        ]
        }
      },
      mounted(){
        this.getList()
      },
      watch:{
        taskRaw(item) {
          this.getList({rawId:item.rawId})
        }
      },
      methods:{
        toggleTaskRaw(){
          this.toggleVisible('taskRaw')
          this.setState({taskRaw:{}})
        },
        itemUpdate(item,id){
          const newData = [...this.list.records]
          const targets = newData.filter(item => id === item.id)[0]
          if (targets) {
            this.list.records = newData
            Object.assign(targets, item)
            this.list.records = newData
          }
        },
        update(){},
        getList(arg={}){
          this.fetchGet({
            actions:this.selectTaskRawFormulaByRawId,
            name:'list',
            loading:"rawListLoading",
            data:{
              current:1,
              taskId:this.detail.id,
              rawId:this.taskRaw.rawId,
              size:50,
              ...arg
            }
          })
        }
      }
  }
</script>

<style scoped lang="scss">
  .close-button{
    font-size: 20px;
  }
  .red{color:red}
  .green{color:green}
  .modalStyle{
    padding:10px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #fff;
    z-index: 2;
  }
</style>